import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/MALogo.svg';
import Footer from '../Footer';
import BottomPlayerTabs from './BottomPlayerTabs';
import PlaylistSidebar from './PlaylistSidebar'
import ToastNotification from '../ToastNotification';
import meleeImage from '../../assets/thumbnails/fox-throw.jpeg';
import { setFlattenedCourse, setVideoTitle, setCurrentVideoPosition, setCurrentVideoMetaData } from '../../features/videoPlayer/videoPlayer.slice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons';
import VideoPlayer from './VideoPlayer';
import VideoDescription from './VideoDescription';

const VideoPageDisplay = ({id}) => {

  const [course, setCourse] = useState([]);
  const [video, setVideo] = useState('');
  const [serverMessage, setServerMessage] = useState(null);
  const [fullAccess, setFullAccess] = useState(false);
  // const [flattenedCourse, setFlattenedCourse] = useState([]);

  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const dispatch = useDispatch();
  
  const fetchCourseData = async () => {
      try {
          const response = await fetch(`${apiUrl}/videos/foundation/foundation/`, {
              method: 'GET',
              // include: 'credentials',
              headers: {
                  'Content-Type': 'application/json',
              },
          });

          const data = await response.json();
          if (data.success) {

              setCourse(data.courseVideos);

              const flattenedCourseVideos = data.courseVideos.reduce((acc, section) => {
                const videosWithSection = section.videos.map((video) => ({
                  ...video,
                  section: section.section, // Add the section name to each video
                }));
                return acc.concat(videosWithSection); // Combine the current section's videos with the accumulator
              }, []);

              dispatch(setFlattenedCourse(flattenedCourseVideos));

              const videoPosition = flattenedCourseVideos.findIndex(video => video.id === id);
              dispatch(setCurrentVideoPosition(videoPosition));
              dispatch(setCurrentVideoMetaData(flattenedCourseVideos[videoPosition]));
              dispatch(setVideoTitle(flattenedCourseVideos[videoPosition]?.name || 'Title Not Found'));

              // After successfully fetching course data, check user subscription

              await getUserSubscription();
          } else {
              //call serverMessage component to show error message
              setServerMessage(data);
              console.error('Error fetching course data:', data.message);
          }
      }
      catch (error) {
        console.error('Error fetching course data:', error);
        setServerMessage({ success: false, message: "An error occurred while fetching course data: " + error.message });
      }
  }

  // Must handle course lock down logic based on this but be careful if user is not logged in
  const getUserSubscription = async () => {
    try {
        const response = await fetch(`${apiUrl}/subscription/verify-access/`, {
            method: 'GET',
            credentials: 'include', // Include cookies in the request
            headers: {
                'Content-Type': 'application/json',
            },
        });

        const data = await response.json();

        if (data.success) {
            // Handle the subscription data as needed
            setFullAccess(data.success);
        }

    } catch (error) {
        console.error('Error while verifying user subscription access but course data should be fetched:', error);
        throw error; // Propagate the error to the caller
    }
  }

  // Update the video state when course data is fetched
  const updateVideo = () => {
    if(course.length > 0) {
      const video = course
        .flatMap((item) => item.videos) // Flatten all videos into a single array
        .find((vod) => vod.id === id); // Match the video by id
      setVideo(video); // Set the entire video object into the state
    }
  };

  useEffect(() => {
      fetchCourseData();
  }, []);

  // Update the video whenever the id or course changes
  useEffect(() => {
    updateVideo();
  }, [id, course]);

  return (
    <div className="wrapper">
      <div id="content-wrap">
        <div className="d-flex justify-content-center mb-4" style={{paddingTop: "40px", cursor: "pointer"}}>
            <div className="d-none d-lg-flex align-items-center" onClick={() => navigate('/')}>
              <img src={Logo} alt="Melee Academy Logo" style={{width: "50px", marginRight: "12px"}}/>
              <h2 style={{fontWeight: 600}}>Melee Academy</h2>
            </div>
            <div className="d-flex align-items-center d-lg-none">
              <div className="d-flex justify-content-start align-items-center" style={{ cursor: "pointer" }}>
                <FontAwesomeIcon icon={faArrowLeftLong} style={{ fontSize: "24px", color: "white" }} onClick={() => navigate('/tutorials/foundation')} />
              </div>
              <h2 className="ms-2">Melee Foundation</h2>
            </div>
        </div>
        <div className="video-page-container">
          <div className='video-page-row'>

            <div className='video-section'>
              <VideoPlayer id={video.id} title={video.name} thumbnail={video.thumbnail_uri} />
              <div className='d-none d-lg-flex'>
                <VideoDescription contributor={video.contributor} description={video.description} />
              </div>
              {/* Dynamic Bottom Section. Needs renaming. */}
              <BottomPlayerTabs id={video.id} contributor={video.contributor} description={video.description} title={video.name} thumbnail={video.thumbnail_uri} course={course} fullAccess={fullAccess} />
            </div>
            <div className='d-none d-lg-flex'>
              <PlaylistSidebar course={course} fullAccess={fullAccess}/>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ToastNotification
        message={serverMessage} 
        setServerMessage={() => setServerMessage(null)} // Clear the message after displaying it
      />
    </div>
  );
};

export default VideoPageDisplay;